import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, InputNumber, Space } from "antd";
import { cn } from "libs/classnames";

/**
 * @param {Object} props
 * @param {string} props.name
 * @returns {JSX.Element}
 */
const NumberStepper = ({ name }) => {
	const form = Form.useFormInstance();
	const value = Form.useWatch(name);

	const handleDecrement = () => {
		if (!value) return;
		form.setFieldValue(name, value - 1);
	};

	const handleIncrement = () => {
		form.setFieldValue(name, value + 1);
	};

	return (
		<>
			<Form.Item
				className={cn(
					"px-4",
					"[&_.ant-form-item-control-input-content]:flex",
					"[&_.ant-form-item-control-input-content]:justify-center",
				)}
			>
				<Space.Compact>
					<Button icon={<MinusOutlined />} onClick={handleDecrement} />
					<Form.Item noStyle name={name} initialValue={0}>
						<InputNumber
							min={0}
							className="w-20 [&_.ant-input-number-input]:text-center"
							readOnly
							type="number"
						/>
					</Form.Item>
					<Button icon={<PlusOutlined />} onClick={handleIncrement} />
				</Space.Compact>
			</Form.Item>
		</>
	);
};

export default NumberStepper;
